module.exports = __webpack_public_path__ + "static/integrations-tech-31a0c252b05aeb3e041a8180aaabe3a6.png";